import React, { useContext, useEffect, useState } from "react";
import { AppointmentContext } from "../context/AppointmentContext";
import config from "../config";
import { PulseLoader } from "react-spinners";
import { generateOneTimeToken } from "../utils/authToken";



function Department({ onNext, onPrevious, onReset }) {
  const { setDepartment, hospitalName } = useContext(AppointmentContext);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchdepartment();
  }, [hospitalName]);

  const fetchdepartment = async () => {
    try {
      const tokeng = generateOneTimeToken();
      const response = await fetch(
        `${config.API_BASE_URL}/FetchOnlyMasterValueDoctorDepartment`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-API-Key": tokeng },
          body: JSON.stringify({
            type: hospitalName === "hazra" ? "hazra" : "newtown",
            UHID: " "

          }),
        }
      );

      const data = await response.json();

      const deptArr =
        data?.data?.["doctor-details"]?.map((d) => ({
          id: d.RECORD_ID,
          name: d.RECORD_NAME,
        })) || [];

      setDepartments(deptArr);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching notice list:", error);
      setDepartments([]);
    }
  };

  const handleSelection = (deptName) => {
    const selectedDept = departments.find((dept) => dept.name === deptName);
    if (selectedDept) {
      sessionStorage.setItem("SELECTED_DEPARTMENT_ID", selectedDept.id);
      sessionStorage.setItem("SELECTED_DEPARTMENT", selectedDept.name);
      setDepartment(deptName);
      onNext();
    }
  };


  return (
    <>
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <h5 className="text-success fw-bold">
            {hospitalName === "hazra"
              ? " Chittaranjan National Cancer Institute, Hazra, Kolkata"
              : "Chittaranjan National Cancer Institute, New Town, Kolkata"}
          </h5>
          <h6 className="fw-bold">
            <i class="fa-solid fa-hospital"></i>&nbsp;
            Select Department</h6>
          <div className="border-bottom mb-3 mt-3">
            {/* <h6 className="fw-bold text-center">New</h6> */}
          </div>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
              <div className="text-center">
                <div className="mt-2 fw-semibold "> < PulseLoader /></div>
                <div className="mt-3 ml-1">Laoding Department....</div>
              </div>
            </div>
          ) : departments.length === 0 ? (
            <div className="text-center text-danger fw-semibold">No departments found.</div>
          ) : (
            <div className="row g-3">
              {departments.map((dept) => (
                <div className="col-md-6" key={dept.id}>
                  <div
                    className="custom-option"
                    role="button"
                    onClick={() => handleSelection(dept.name)}
                  >
                    <div
                      className="list-group-item hospital-item mb-2 d-flex justify-content-between align-items-center"
                      style={{ cursor: "pointer" }}
                    >
                      <div>
                        <div className="fw-semibold">
                          <span style={{ fontWeight: "600" }}>
                            <i className="fa-solid fa-pills"></i>
                            &nbsp;&nbsp;{dept.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}


          <div className="d-flex justify-content-between mt-4">
            <button
              onClick={onPrevious}
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-800 text-white text-sm font-semibold rounded-md shadow hover:bg-gray-700 transition duration-150"
            >
              <i className="fas fa-arrow-left"></i>
              Previous
            </button>

            {/* Start Again Button */}
            <button
              onClick={onReset}
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-md shadow hover:bg-blue-700 transition duration-150"
            >
              <i className="fas fa-rotate-right"></i>
              Start Again
            </button>
          </div>

        </div>
      </div>
    </>
  );
}

export default Department;
